import React from 'react'
import routes from '../../../config/routes'
import Text from '../../commons/Text/Text'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import Button from '../../commons/Button/Button'
import FlameSantander from '../../commons/Icons/FlameSantander'
import Link from '../../commons/Link/Link'
import styles from './recoveryPasswordResentEmailFeedbackContainer.module.scss'

const RecoveryPasswordResentEmailFeedbackContainer = () => {
  return (
    <ExternalLayout>
      <div className={styles.container}>
        <FlameSantander />
        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Reenviamos o e-mail
        </Text>
        {/* <Text color="gray" variation="dark" size="md" margin="10px 0px">
          Reenviamos o link no thaoliveira@santander.com.br não recebeu?
          certifique-se de que o endereço informado esta correto e verifique a
          sua caixa de spam.
        </Text> */}
      </div>
      <div className={styles.containerButton}>
        <Link to={routes.login.path}>
          <Button
            type="outlined_dark"
            margin="12px 10px 0px"
            buttonType="button"
            width="160px"
          >
            <Text
              font="custom"
              color="gray"
              variation="dark"
              size="xs"
              value="Login"
              bold
            />
          </Button>
        </Link>

        <Link to={routes.resetPasswordSentEmail.path}>
          <Button
            type="secondary"
            margin="12px 0 0"
            buttonType="submit"
            width="160px"
          >
            <Text
              font="custom"
              color="white"
              size="xs"
              value="Alterar e-mail"
              bold
            />
          </Button>
        </Link>
      </div>
    </ExternalLayout>
  )
}

export default RecoveryPasswordResentEmailFeedbackContainer
